let ContactWindow = null;
Replace_Disabled_Add_Buttons_With_Contact()
window.setInterval(Replace_Disabled_Add_Buttons_With_Contact, 1000);

function Replace_Disabled_Add_Buttons_With_Contact(){
    let to_remove_elements = document.querySelectorAll("[name='add'][disabled]")
    for (elem of to_remove_elements){

        let new_button = document.createElement("button")
        new_button.classList = elem.classList
        new_button.setAttribute("type","button")
        new_button.innerHTML = "Contact"
        elem.replaceWith(new_button)
        new_button.addEventListener("click",Trigger_Contact_Form)
    }
}

function Trigger_Contact_Form(event){
  let product_id = event.target.closest("form").querySelector("input[name='id']").value

  if (ContactWindow === null || ContactWindow.closed) {
     ContactWindow = window.open(`https://whitebearphotonics.com/pages/product-inquiry?product=${product_id}`,"ContactWindow")

  } else {
    ContactWindow.focus();
  }
  
}